export { default } from "./HighlightsWithPhotoBackground";
